import _ from 'lodash'

import config from '@config'

import {
    WON_TENDERS_LOAD_PUBLISHERS_DATA,
    WON_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST,
    WON_TENDERS_PUBLISHERS_TABLE_LOADING_TRUE,
    WON_TENDERS_PUBLISHERS_TABLE_LOADING_FALSE,
    WON_TENDERS_PUBLISHERS_TABLE_LOADING_FAILED,
    WON_TENDERS_PUBLISHERS_TABLE_DATA_RECEIVED,
} from './constants'

export const loadPublishersData = (module, block, entId, level, tenderId) => ({
    type: WON_TENDERS_LOAD_PUBLISHERS_DATA,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
    },
})

export const loadTableDataRequest = (module, block, entId, level, lang, token, tenderId, queryParams) => ({
    type: WON_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST(entId, tenderId),
    payload: {
        uri: _.get(config, `api.${module}.${block}.tables.suppliedTendersPublishers.uri`),
        qs: {
            ...queryParams,
            entId,
            lang,
            token,
            level,
            procurementType: 'sup',
            procurementId: tenderId,
        },
        uriParams: {
            entId,
            lang,
        },
        headers: {
            'X-Token': token,
        },
    },
})

export const publishersTableLoadingTrue = (module, block, entId, level, tenderId, data) => ({
    type: WON_TENDERS_PUBLISHERS_TABLE_LOADING_TRUE,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const publishersTableLoadingFalse = (module, block, entId, level, tenderId, data) => ({
    type: WON_TENDERS_PUBLISHERS_TABLE_LOADING_FALSE,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const publishersTableLoadingFailed = (module, block, entId, level, tenderId, data) => ({
    type: WON_TENDERS_PUBLISHERS_TABLE_LOADING_FAILED,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const publishersTableDataReceived = (module, block, entId, level, tenderId, data) => ({
    type: WON_TENDERS_PUBLISHERS_TABLE_DATA_RECEIVED,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})
